import * as React from 'react';
import { cn } from '../../utils/cn/cn';

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  badgeContent: React.ReactNode;
}

export const Badge = ({ className, children, badgeContent, ...props }: BadgeProps) => (
  <div className={cn('relative inline-flex align-middle', className)} {...props}>
    {children}
    <span className="bg-color-primary text-size-body3 text-color-primary-contrasttext absolute top-0 right-0 box-border flex h-2 min-w-2 origin-top-right translate-x-1/2 -translate-y-1/2 flex-row flex-wrap items-center justify-center rounded-full px-0.5 whitespace-nowrap">
      {badgeContent}
    </span>
  </div>
);
